import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import type { Product } from "../types";

/**
 * IDs of products recommended for the current visitor — logged in or not —
 * based on their browsing/search/cart interactions (tracked anonymously
 * before login via a session cookie, then merged into the account on
 * login/signup). Used to silently bump these to the top of catalog listings
 * rather than calling them out in a separate section.
 */
export default function useRecommendedIds() {
  const { user } = useAuth();
  const [ids, setIds] = useState<Set<string>>(new Set());

  useEffect(() => {
    fetch("/api/recommendations")
      .then((res) => (res.ok ? res.json() : []))
      .then((data: Product[]) => setIds(new Set(data.map((p) => p.id))))
      .catch(() => {});
  }, [user]);

  return ids;
}
